<!--
Created on Thu Jun 01 2023

Copyright (c) Cynnox, Inc - All Rights Reserved 2023 Jagan

Unauthorized copying of this file, via any medium is strictly prohibited
Proprietary and confidential Written by Jagan <jagancpj246@gmail.com>, September 2020.
-->

<!-- Personal info -->
<div class="mt-2">
  <div
    style="
      cursor: pointer;
      display: flex;
      border-radius: 8px;
      padding: 5px;
      align-items: center;
    "
    (click)="dataCollected['personalInfo'] = !dataCollected['personalInfo']"
    (mouseover)="isOver['personalInfo'] = true"
    (mouseleave)="isOver['personalInfo'] = false"
    [ngStyle]="{
      'background-color': isOver['personalInfo'] ? '#d9d9d926' : 'unset'
    }"
    >
    <div style="margin: auto 0; margin-top: 3px; color: rgb(95, 99, 104)">
      <ion-icon name="person-circle-outline" style="font-size: 30px"></ion-icon>
    </div>

    <div class="ml-2 flex-grow-1" style="margin-left: 10px; flex: 1">
      <h4 style="font-weight: 500">Personal info</h4>
      <h5 style="color: rgb(95, 99, 104)">Name, Email address</h5>
    </div>

    <div class="ml-2">
      @if (!dataCollected['personalInfo']) {
        <ion-icon
          name="chevron-down"
          style="font-size: 25px"
        ></ion-icon>
      }

      @if (dataCollected['personalInfo']) {
        <ion-icon
          name="chevron-up"
          style="font-size: 25px"
        ></ion-icon>
      }
    </div>
  </div>

  @if (dataCollected['personalInfo']) {
    <div
      style="border: 1px solid; border-radius: 5px; padding: 10px"
      >
      <div style="font-weight: 500" class="my-2 d-flex">
        <h4>Data collected and for what purpose</h4>
      </div>
      <div class="my-2">
        <h5 style="font-weight: 500">Name</h5>
        <p style="font-size: 12px; color: rgb(95, 99, 104)">
          App functionality, Developer communications, Personalisation, Account
          management.
        </p>
      </div>
      <div class="my-2">
        <h5 style="font-weight: 500">Email address</h5>
        <p style="color: rgb(95, 99, 104); font-size: 12px">
          App functionality, Developer communications, Account management.
        </p>
      </div>
    </div>
  }
</div>
